import { FC } from 'react';
import { Heading, Container, Box } from 'roo-ui/components';

import LoadingPage from 'pages/LoadingPage';
import { ConnectedGatekeeperLoginForm } from './GatekeeperLoginForm';
import NoAccessAlert from './NoAccessAlert';
import NonMemberInfo from './NonMemberInfo';
import OAuthLoginForm from './OAuthLoginForm';

import { useLocation } from 'react-router';
import { FLAG_RELATIONSHIP_LOGIN_ENABLED, RELATIONSHIP_BASE_URL } from 'config/env';

interface Props {
  isSSO?: boolean;
  hasInitializedSSO?: boolean;
  bookingId?: string;
}

const LoginPage: FC<Props> = ({ isSSO = false, hasInitializedSSO, bookingId }) => {
  const location = useLocation();
  const isOBT = location.pathname.includes('business/bookings');

  const renderLoginForm = () => {
    if (FLAG_RELATIONSHIP_LOGIN_ENABLED) {
      const relationshipUrl = `${RELATIONSHIP_BASE_URL}${location.pathname}${location.search}`;
      window.location.replace(relationshipUrl);
      return null;
    }

    if (isSSO) {
      return <OAuthLoginForm />;
    }

    if (!bookingId) {
      return <NoAccessAlert mt={9} />;
    } else {
      return <ConnectedGatekeeperLoginForm bookingId={bookingId} isOBT={isOBT} />;
    }
  };

  if (isSSO && !hasInitializedSSO) {
    return <LoadingPage />;
  }

  return (
    <Container py={10} px={[0, 3]} maxWidth="login">
      <Box mx={4}>
        <Heading.h1 fontSize={['2xl', '3xl']}>Manage your hotel bookings</Heading.h1>
        {!isOBT && (
          <>
            <Box my={[4, 6]}>Log in with your Frequent Flyer account to view your Qantas Hotels bookings</Box>
            <NonMemberInfo bookingId={bookingId} />
          </>
        )}
      </Box>
      {renderLoginForm()}
    </Container>
  );
};

export default LoginPage;
